import {
  ConsultoryState,
  LoadingScheduleDay,
  ModulesResponse
} from '@/store/consultories/types'
import { Doctor } from '@/store/doctor/types'

export const state: ConsultoryState = {
  loadingConsultoriesList: true,
  loadingCreateConsultory: false,
  loadingConsultoryModules: true,
  consultoriesList: [],
  modules: {} as ModulesResponse,
  loadingDoctors: false,
  doctors: [],
  doctorSearch: {} as Doctor,
  loadingSerachDoctor: false,
  moduleSchedule: [],
  loadingModuleSchedule: false,
  loadingScheduleDay: {} as LoadingScheduleDay,
  moduleEvents: [],
  loadingEvents: false
}
